module.exports = __webpack_public_path__ + "static/media/image-1200.a7db84e5.jpg";